<app-page-title [title]="title"></app-page-title>

<div class="card cost-detail">
  <div class="card-body">
    <div class="d-flex flex-wrap align-items-center gap-2 mb-3">
      <h5 class="text-primary mb-0 me-auto">Özet</h5>

      <div class="input-group input-group-sm date-filter">
        <input placeholder="Başlangıç" (click)="beginDate.toggle()" class="form-control" name="beginDatePicker"
          [(ngModel)]="beginDateModel" (ngModelChange)="dateChanged()" ngbDatepicker #beginDate="ngbDatepicker"
          autocomplete="off">
        <button class="btn border" (click)="beginDate.toggle()" type="button"><i class="far fa-calendar"></i></button>
      </div>
      <div class="input-group input-group-sm date-filter">
        <input placeholder="Bitiş" (click)="endDate.toggle()" class="form-control" name="endDatePicker"
          [(ngModel)]="endDateModel" (ngModelChange)="dateChanged()" ngbDatepicker #endDate="ngbDatepicker"
          autocomplete="off">
        <button class="btn border" (click)="endDate.toggle()" type="button"><i class="far fa-calendar-alt"></i></button>
      </div>
      <button class="btn btn-sm btn-outline-info" (click)="clearDates()" triggers="hover" placement="auto"
        container="body" ngbTooltip="Tarih filtresini temizle">
        <i class="fas fa-trash-alt"></i>
      </button>
      <button class="btn btn-sm btn-outline-secondary" (click)="backToCosts()">
        <i class="fas fa-arrow-left"></i> Maliyetler
      </button>
    </div>

    <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-3 row-cols-xxl-5 g-2" *ngIf="detail">
      <div class="col">
        <div class="stat">
          <div class="stat-label">
            Birim Maliyet
            <i class="fas fa-info-circle text-muted" triggers="hover" placement="auto" container="body"
              ngbTooltip="Kayıt birimi has; TL ve USD karşılığı bugünkü kurla."></i>
          </div>
          <div class="stat-values">
            <span><small class="text-muted">TL</small> <b>{{ detail.costTL ? (detail.costTL | costAmount) : '-' }}</b></span>
            <span><small class="text-muted">USD</small> <b>{{ detail.costUSD ? (detail.costUSD | costAmount) : '-' }}</b></span>
            <span><small class="text-muted">HAS</small> <b>{{ detail.costHAS ? (detail.costHAS | costAmount) : '-' }}</b></span>
          </div>
          <div class="stat-note">
            <ng-container *ngIf="detail.costDate">Son alış: {{ detail.costDate | date:'dd.MM.y HH:mm' }}</ng-container>
            <ng-container *ngIf="!detail.costDate">Bu birimin alışı yok.</ng-container>
          </div>
        </div>
      </div>

      <div class="col">
        <div class="stat">
          <div class="stat-label">
            Stok
            <i class="fas fa-info-circle text-muted" triggers="hover" placement="auto" container="body"
              ngbTooltip="Defter stoğu alım/satım işlemlerinden, şube transferlerinden, açılış stoğundan ve kasa hareketlerinden hesaplanır."></i>
          </div>
          <div class="stat-main" [ngClass]="detail.stock >= 0 ? 'text-primary' : 'text-danger'">
            {{ detail.stock | currencyAmount: detail.currency }}
          </div>
          <div class="stat-note">
            Kasa: <b>{{ detail.caseBalance | currencyAmount: detail.currency }}</b>
            <span *ngIf="hasStockGap()" [ngClass]="detail.stockDifference > 0 ? 'text-warning' : 'text-danger'">
              · Fark: <b>{{ detail.stockDifference | currencyAmount: detail.currency }}</b>
            </span>
          </div>
        </div>
      </div>

      <div class="col">
        <div class="stat">
          <div class="stat-label">Alış / Satış</div>
          <div class="stat-values">
            <span><span class="badge bg-success">{{ detail.purchaseCount }} alış</span>
              <b>{{ detail.purchaseAmount | currencyAmount: detail.currency }}</b></span>
            <span><span class="badge bg-danger">{{ detail.saleCount }} satış</span>
              <b>{{ detail.saleAmount | currencyAmount: detail.currency }}</b></span>
          </div>
          <div class="stat-note" *ngIf="detail.firstDate">
            {{ detail.firstDate | date:'dd.MM.y' }} - {{ detail.lastDate | date:'dd.MM.y' }}
          </div>
        </div>
      </div>

      <div class="col">
        <div class="stat">
          <div class="stat-label">
            İşlem Farkı
            <i class="fas fa-info-circle text-muted" triggers="hover" placement="auto" container="body"
              ngbTooltip="Uygulanan kurun günün kurundan sapması, has gram. Kâr değildir: piyasanın altında alım ya da üstünde satış buraya yazılır."></i>
          </div>
          <div class="stat-main" [ngClass]="detail.marketDifferenceHAS >= 0 ? 'text-success' : 'text-danger'">
            {{ detail.marketDifferenceHAS | number: '1.3-3' }}
          </div>
          <div class="stat-note">has gram</div>
        </div>
      </div>

      <div class="col">
        <div class="stat">
          <div class="stat-label">Satışlarda Gerçekleşen Kâr</div>
          <div class="stat-values">
            <span [ngClass]="detail.profitTL >= 0 ? 'text-success' : 'text-danger'">
              <small class="text-muted">TL</small> <b>{{ detail.profitTL | number: '1.2-2' }}</b>
            </span>
            <span [ngClass]="detail.profitUSD >= 0 ? 'text-success' : 'text-danger'">
              <small class="text-muted">USD</small> <b>{{ detail.profitUSD | number: '1.2-2' }}</b>
            </span>
            <span [ngClass]="detail.profitHAS >= 0 ? 'text-success' : 'text-danger'">
              <small class="text-muted">HAS</small> <b>{{ detail.profitHAS | number: '1.3-3' }}</b>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="alert alert-warning alert-compact mt-2 mb-0" *ngIf="hasStockGap()">
      <i class="fas fa-exclamation-triangle"></i>
      Kasa bakiyesi ile defter stoğu tutmuyor: <b>{{ detail.stockDifference | currencyAmount: detail.currency }}</b>
      fark var.
      <i class="fas fa-info-circle text-muted" triggers="hover" placement="auto" container="body"
        ngbTooltip="Defter artık kasa hareketlerini de izlediği için bu iki rakam normalde örtüşür. Fark görüyorsanız: şube henüz Yeniden Hesapla ile güncellenmemiş olabilir, açılış stoğu kasa geçmişiyle çakışıyor olabilir ya da bazı hareketlerin o günkü değeri bulunamamış olabilir."></i>
    </div>
    <div class="alert alert-warning alert-compact mt-2 mb-0" *ngIf="detail && detail.unprocessedCount > 0">
      <i class="fas fa-exclamation-triangle"></i>
      Maliyeti yeni yöntemle hesaplanmamış <b>{{ detail.unprocessedCount }}</b> işlem var; maliyet ekranındaki
      <b>Yeniden Hesapla</b> ile güncelleyin.
    </div>
    <div class="alert alert-info alert-compact mt-2 mb-0" *ngIf="detail && detail.unknownValueCount > 0">
      <i class="fas fa-info-circle"></i>
      <b>{{ detail.unknownValueCount }}</b> işlemin değeri bilinmiyor; maliyeti <b>Birim Maliyeti Ekle</b> ile girilebilir.
    </div>
  </div>
</div>

<div class="card cost-detail" [ngClass]="{'blur-content': Loading }">
  <div class="card-body">
    <div class="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-2">
      <h5 class="text-primary mb-0">İşlemler</h5>
      <div class="btn-group btn-group-sm">
        <button class="btn" [ngClass]="listRequest.direction == Direction.All ? 'btn-primary' : 'btn-outline-primary'"
          (click)="changeDirection(Direction.All)">Tümü</button>
        <button class="btn" [ngClass]="listRequest.direction == Direction.Purchase ? 'btn-primary' : 'btn-outline-primary'"
          (click)="changeDirection(Direction.Purchase)">Alışlar</button>
        <button class="btn" [ngClass]="listRequest.direction == Direction.Sale ? 'btn-primary' : 'btn-outline-primary'"
          (click)="changeDirection(Direction.Sale)">Satışlar</button>
      </div>
    </div>

    <list-spinner class="center-body" [showSpinner]="Loading"
      [length]="listResponse ? listResponse.data.Items.length : 0"></list-spinner>

    <div class="table-responsive" *ngIf="listResponse && listResponse.data.Items.length > 0">
      <table class="table table-borderless table-hover table-sm align-middle compact-table">
        <thead>
          <tr>
            <th>Tarih</th>
            <th class="text-center">Yön</th>
            <th class="text-end">Miktar</th>
            <th class="text-end">Karşılık</th>
            <th class="text-end">Parite</th>
            <th class="table-danger text-end">Birim Maliyet (TL)</th>
            <th class="text-end">Kâr (TL)</th>
            <th class="text-end">Kâr (USD)</th>
            <th class="text-end">Kâr (HAS)</th>
            <th class="text-end">Fark (HAS)</th>
            <th>Müşteri</th>
            <th>Durum</th>
            <th class="text-center">İşlem</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of listResponse.data.Items">
            <td class="text-nowrap">{{ item.agreedDate | date:'dd.MM.y HH:mm' }}</td>
            <td class="text-center">
              <span class="badge" [ngClass]="isPurchase(item) ? 'bg-success' : 'bg-danger'">
                {{ isPurchase(item) ? 'Alış' : 'Satış' }}
              </span>
            </td>
            <td class="text-end">{{ amountOf(item) | currencyAmount: currency }}</td>
            <td class="text-end text-nowrap">
              <ng-container *ngIf="isPurchase(item)">
                {{ item.exchangeAmount | currencyAmount: item.exchangeCurrency }}
                <small class="text-muted">{{ item.exchangeCurrency | priceCurrency: item.exchangeSubType }}</small>
              </ng-container>
              <ng-container *ngIf="!isPurchase(item)">
                {{ item.paymentAmount | currencyAmount: item.paymentCurrency }}
                <small class="text-muted">{{ item.paymentCurrency | priceCurrency: item.paymentSubType }}</small>
              </ng-container>
            </td>
            <td class="text-end">{{ item.parity | currencyAmount: null: null: true }}</td>
            <td class="table-danger text-end">
              <span *ngIf="isPurchase(item)">{{ item.costTL ? (item.costTL | costAmount) : '-' }}</span>
              <span *ngIf="!isPurchase(item)" class="text-muted">-</span>
            </td>
            <td class="text-end" [ngClass]="{'text-success': item.profitTL > 0, 'text-danger': item.profitTL < 0}">
              <span *ngIf="item.profitTL !== 0">{{ item.profitTL | currencyAmount: null: null: true }}</span>
              <span *ngIf="item.profitTL === 0" class="text-muted">-</span>
            </td>
            <td class="text-end" [ngClass]="{'text-success': item.profitUSD > 0, 'text-danger': item.profitUSD < 0}">
              <span *ngIf="item.profitUSD !== 0">{{ item.profitUSD | currencyAmount: null: null: true }}</span>
              <span *ngIf="item.profitUSD === 0" class="text-muted">-</span>
            </td>
            <td class="text-end" [ngClass]="{'text-success': item.profitHAS > 0, 'text-danger': item.profitHAS < 0}">
              <span *ngIf="item.profitHAS !== 0">{{ item.profitHAS | number: '1.3-3' }}</span>
              <span *ngIf="item.profitHAS === 0" class="text-muted">-</span>
              <i class="fas fa-exclamation-triangle text-warning ms-1" *ngIf="item.uncoveredAmount"
                triggers="hover" placement="auto" container="body"
                ngbTooltip="Defterde bu birimden {{ item.uncoveredAmount }} kadarı yoktu; o kısmın maliyeti ortalamadan tahmin edildi."></i>
            </td>
            <td class="text-end"
              [ngClass]="{'text-success': item.marketDifferenceHAS > 0, 'text-danger': item.marketDifferenceHAS < 0}">
              <span *ngIf="item.marketDifferenceHAS">{{ item.marketDifferenceHAS | number: '1.3-3' }}</span>
              <span *ngIf="!item.marketDifferenceHAS" class="text-muted">-</span>
            </td>
            <td class="text-truncate customer-cell" [title]="item.customerName">{{ item.customerName }}</td>
            <td innerHtml="{{ item | exchangeItemState }}"></td>
            <td class="text-center">
              <button class="btn btn-primary btn-sm" routerLink="/exchange/detail/{{item.id}}" title="İşlem detayı">
                <i class="mdi mdi-eye"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="listResponse && listResponse.data.TotalItemCount > 0">
      <app-pagination [blurOn]="Loading" [pageInfo]="listResponse.data" [pageRequest]="listRequest"
        (requestEvent)="reloadList()">
      </app-pagination>
    </div>
  </div>
</div>
